import ufeApi from 'services/api/ufeApi';

// https://confluence.sephora.com/wiki/spaces/ILLUMINATE/pages/120042007/Set+Nickname+API

function setNickname(nickname, provider, source) {
    const url = '/gway/v2/users/profiles/nickname';

    const params = {
        isAcceptCommunity: true,
        nickName: nickname,
        provider
    };

    if (source) {
        params.source = source;
    }

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(params)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default setNickname;
